import { useCallback, useEffect, useState } from "react";
import { supabase } from "../../Services/supabaseClient";

const useCrmPermissions = () => {
  const [role, setRole] = useState("member");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);

    try {
      const {
        data: { user },
        error: userError,
      } = await supabase.auth.getUser();

      if (userError) {
        throw userError;
      }

      if (!user?.id) {
        setRole("member");
        return;
      }

      const { data, error } = await supabase
        .from("company_members")
        .select("role")
        .eq("user_id", user.id)
        .maybeSingle();

      if (error) {
        throw error;
      }

      setRole(data?.role || "member");
    } catch (error) {
      setRole("member");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return {
    role,
    loading,
    isAdmin: role === "admin",
    isMember: role === "member",
    canManageSettings: role === "admin",
    canConvertQuote: role === "admin",
    canEditRecords: role === "admin" || role === "member",
    canCreateRecords: role === "admin" || role === "member",
  };
};

export default useCrmPermissions;
